/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type {
  IEngagementOracle,
  IEngagementOracleInterface,
} from "../../../contracts/interfaces/IEngagementOracle";

const _abi = [
  {
    inputs: [],
    name: "EngagementOracle_OnlyWriter",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint8",
        name: "tier",
        type: "uint8",
      },
    ],
    name: "TierSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [],
    name: "TiersReset",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user_",
        type: "address",
      },
    ],
    name: "getUserTier",
    outputs: [
      {
        internalType: "uint8",
        name: "tier",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "resetTiers",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user_",
        type: "address",
      },
      {
        internalType: "uint8",
        name: "tier_",
        type: "uint8",
      },
    ],
    name: "setTier",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "user",
            type: "address",
          },
          {
            internalType: "uint8",
            name: "tier",
            type: "uint8",
          },
        ],
        internalType: "struct IEngagementOracle.UserTierParams[]",
        name: "userTiersParams",
        type: "tuple[]",
      },
    ],
    name: "setTiersBatch",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "dataWriter_",
        type: "address",
      },
    ],
    name: "setWriter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

export class IEngagementOracle__factory {
  static readonly abi = _abi;
  static createInterface(): IEngagementOracleInterface {
    return new Interface(_abi) as IEngagementOracleInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): IEngagementOracle {
    return new Contract(address, _abi, runner) as unknown as IEngagementOracle;
  }
}
